import { ResourceForm } from '@/components/admin/ResourceCreator'
import { Resource } from '@/store/admin'
import { Button } from '@repo/ui/button'
import { CardDescription, CardTitle } from '@repo/ui/card'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { PenLine } from 'lucide-react'
import { useState } from 'react'

export function ResourceEditor({ resource }: { resource: Resource }) {
  const { tc, t } = useT({ keyPrefix: 'resourceEditor' })
  const [open, setOpen] = useState(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
          <PenLine className="size-4" /> {tc('edit', { cfl: true })}
        </Button>
      </DialogTrigger>

      <DialogContent size="wide" disableOutsideClick>
        <DialogHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
        </DialogHeader>

        <ResourceForm
          editableResource={resource}
          onSubmitted={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
